/* eslint-disable @typescript-eslint/no-unused-vars */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpHelperService } from '../../shared/services/http-helper.service';
import { Observable } from 'rxjs';
import { Page } from '../models/page-metadata.model';
import { IComment } from '@cod-monorepo/interfaces';

@Injectable({
    providedIn: 'root'
})
export class CommentService {
    protected baseUrl = environment.apiUrl;

    constructor(private httpClient: HttpClient, private httpHelperService: HttpHelperService) {}

    public getAllComments(codId: string, page: number, size: number): Observable<Page<IComment>> {
        return this.httpClient
            .get<Page<IComment>>(`${this.baseUrl}/cods/${codId}/comments`, {
                params: {
                    page: page.toString(),
                    pageSize: size.toString(),
                    orderBy: ['createdAt'],
                    sortOrder: 'DESC'
                }
            })
            .pipe(this.httpHelperService.handleError('Cannot fetch all comments'));
    }

    public createComment(codId: string, comment: Partial<IComment>): Observable<IComment> {
        return this.httpClient
            .post<IComment>(`${this.baseUrl}/cods/${codId}/comments`, comment)
            .pipe(this.httpHelperService.handleError('Cannot create comment'));
    }

    public deleteComment(codId: string, commentId: string): Observable<void> {
        return this.httpClient
            .delete<void>(`${this.baseUrl}/cods/${codId}/comments/${commentId}`)
            .pipe(this.httpHelperService.handleError('Cannot delete comment'));
    }
}
